<template>
  <!-- 添加工作或实习经历的对话框 -->
    <div class="studyModal">
      <a-modal
       :title="biaoji ? '修改工作经历' : '添加工作经历'"
       :visible="showVisible"
       okText="下一步"
       :footer="null"
       @cancel="cancel"
       :dialogStyle="dialogStyle"
      >



   
          <a-form-model ref="JobRef" :rules="JobRule" :model="formJob" :label-col="labelCol" :wrapper-col="wrapperCol">

            <a-row>
             <a-col :span="12" :offset="1" prop="a4801">
              <a-form-model-item label="起始日期" prop="a4801">
              <a-date-picker :inputReadOnly="true" placeholder="起始日期" show-tiem type="date"  v-model="formJob.a4801" style="width: 180px"></a-date-picker>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
                <a-form-model-item label="截止日期" prop="a4802">
                <a-date-picker :inputReadOnly="true" placeholder="截止日期" show-tiem type="date" v-model="formJob.a4802" style="width: 180px"></a-date-picker>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="组织或公司名称" prop="a4803">
              <a-input :maxLength="20" v-model="formJob.a4803" style="width: 494px"></a-input>
              </a-form-model-item>
             </a-col>
            </a-row>

          <div class="txtarea">
            <a-row>
              <a-col :span="15">
                <a-form-model-item label="工作单位及职务" prop="a4805">
                <a-input :maxLength="300" :auto-size="{ minRows: 5, maxRows: 6 }" type="textarea" :cols="20" :rows="5" placeholder="若为学生，职务可不填写" v-model="formJob.a4805"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>
            
            

          </a-form-model>


         <div class="dialogFooter">
        <!-- 保存 -->
        <button class="btnStyle1" @click="addWorkExperience" v-show="!biaoji">保存</button>
         <!-- 修改 -->
        <button class="btnStyle1" @click="updateWorkExperience" v-show="biaoji">保存</button>
        <!-- 取消 -->
        <button class="btnStyle1" @click="cancel">取消</button>
      </div>

      </a-modal>
    </div>
</template>


<script>
import moment from 'moment'
export default {
  props:{
    JobVisible:{
      type:Boolean,
      require:true
    },
    jobInfo:{
      type:Object,
      require:true
    }
  },

  data(){
    return{
       labelCol: { span: 9 },
      wrapperCol: { span: 10 },


      showVisible:false,

      //实习或工作经历表单数据
      formJob:{},

      //biaoji
      biaoji:null,

      dialogStyle: {
        right:"100px"
      },


       //学历下拉框数据
      educationList:[
        {
          id:1,
          vl:'研究生'
        },
        {
          id:2,
          vl:'大学本科生'
        },
        {
          id:3,
          vl:'大学普通班'
        },
        {
          id:4,
          vl:'大学专科'
        },
        {
          id:5,
          vl:'高中'
        }
      ],


      //校验规则
      JobRule:{
        a4801: [
          { required: true, message: '请输入起始日期', trigger: 'change' },
        ],
        a4802: [
          { required: true, message: '请输入结束日期', trigger: 'change' },
        ],
        a4803: [
          { required: true, message: '请输入组织或公司名称', trigger: 'blur' },
        ],
        a4805: [
        ],
      }

    }
  },


  mounted(){
    this.showVisible=this.JobVisible
  },

  watch:{
    JobVisible(){
      this.showVisible=this.JobVisible
    },
    jobInfo(){
      this.formJob=this.jobInfo
      this.biaoji=this.jobInfo.biaoji
    }
  },


  methods:{
    //点击了保存工作经历的按钮
    addWorkExperience(){
      // 格式化日期的函数
       function getTargetTime(t){
        var d = t.split(" ")[0],
        h = t.split(" ")[1],
        date = new Date()

        date.setYear(d.split("-")[0])
        date.setMonth(d.split("-")[1] - 1)
        date.setDate(d.split("-")[2])

    
        return date.getTime()    
      }
      this.$refs.JobRef.validate(valid => {
        if(!valid) return this.$message.warning('请完成表单内容')
      this.formJob.a00=sessionStorage.getItem('aabb')
      //格式化日期
      if(!valid) return this.$message.warning('请完成表单内容')
       //格式化日期
      if(typeof(this.formJob.a4801)=='string'){
        if(getTargetTime(this.formJob.a4801)>new Date().getTime()) return this.$message.warning('起始时间不能晚于当前时间');
      }else{
       if((this.formJob.a4801).unix()*1000>new Date().getTime()) return this.$message.warning('起始时间不能晚于当前时间');
      }

       if(typeof(this.formJob.a4801)=='string'&&(typeof(this.formJob.a4802)=='string')){
         console.log(1);
         if(getTargetTime(this.formJob.a4801)>getTargetTime(this.formJob.a4802)) return this.$message.warning('起始时间不能晚于截止时间');
       }else if(typeof(this.formJob.a4801)=='string'){
         console.log(2);
         if(getTargetTime(this.formJob.a4801)>(this.formJob.a4802).unix()*1000) return this.$message.warning('起始时间不能晚于截止时间');
       }else if(typeof(this.formJob.a4802)=='string'){
         console.log(3);
         if((this.formJob.a4801).unix()*1000>getTargetTime(this.formJob.a4802)) return this.$message.warning('起始时间不能晚于截止时间');
       }else{
         console.log(4);
         if((this.formJob.a4801).unix()>(this.formJob.a4802).unix()) return this.$message.warning('起始时间不能晚于截止时间');
       }
      this.formJob.a4801=moment(this.formJob.a4801).format('YYYY-MM-DD');
      this.formJob.a4802=moment(this.formJob.a4802).format('YYYY-MM-DD');
      this.post({
        url:'addWorkExperience',
        data:this.formJob
      },(res)=>{
        console.log(res);
        if(res.code==200){
          this.$message.success('添加工作经历成功')
          this.$emit('updt')
          this.cancel()
        }
      })
      })
    },
    //点击了修改工作经历的按钮
    updateWorkExperience(){
       // 格式化日期的函数
       function getTargetTime(t){
        var d = t.split(" ")[0],
        h = t.split(" ")[1],
        date = new Date()

        date.setYear(d.split("-")[0])
        date.setMonth(d.split("-")[1] - 1)
        date.setDate(d.split("-")[2])

    
        return date.getTime()    
      }
      this.$refs.JobRef.validate(valid => {
        if(!valid) return this.$message.warning('请完成表单内容')
       //格式化日期
      if(typeof(this.formJob.a4801)=='string'){
        if(getTargetTime(this.formJob.a4801)>new Date().getTime()) return this.$message.warning('起始时间不能晚于当前时间');
      }else{
       if((this.formJob.a4801).unix()*1000>new Date().getTime()) return this.$message.warning('起始时间不能晚于当前时间');
      }

       if(typeof(this.formJob.a4801)=='string'&&(typeof(this.formJob.a4802)=='string')){
         console.log(1);
         if(getTargetTime(this.formJob.a4801)>getTargetTime(this.formJob.a4802)) return this.$message.warning('起始时间不能晚于截止时间');
       }else if(typeof(this.formJob.a4801)=='string'){
         console.log(2);
         if(getTargetTime(this.formJob.a4801)>(this.formJob.a4802).unix()*1000) return this.$message.warning('起始时间不能晚于截止时间');
       }else if(typeof(this.formJob.a4802)=='string'){
         console.log(3);
         if((this.formJob.a4801).unix()*1000>getTargetTime(this.formJob.a4802)) return this.$message.warning('起始时间不能晚于截止时间');
       }else{
         console.log(4);
         if((this.formJob.a4801).unix()>(this.formJob.a4802).unix()) return this.$message.warning('起始时间不能晚于截止时间');
       }

      this.formJob.a4801=moment(this.formJob.a4801).format('YYYY-MM-DD');
      this.formJob.a4802=moment(this.formJob.a4802).format('YYYY-MM-DD');
      this.post({
        url:'updateWorkExperience',
        data:this.formJob
      },(res)=>{
        this.$message.success('修改工作经历成功')
        this.$emit('updt')
        this.cancel()
      })
      })
    },
    //点击了取消
    cancel(){
      this.$refs.JobRef.resetFields()
      this.showVisible=false
      this.$emit('update:JobVisible',false)
      this.$emit('updt')
    }
  }
}
</script>




<style scoped>


.dialogFooter{
  background-color: #e3efff;
  border: 1px solid #c1d7f9;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btnStyle1{
  width: 84px;
  height: 36px;
  background-color: #f1a338;
  font-size: 16px;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border: none;
  border-radius: 3px;
  margin: 10px 5px;
}

.btnStyle1:hover{
  cursor:pointer;
}






/deep/ .ant-modal-content{
  width: 696px!important;
  height: 520px!important;
}


/deep/ .txtarea .ant-form-item-control{
  width: 490px!important;
}


</style>


// WEBPACK FOOTER //
// src/views/zkzw/compos/ssjl.vue